module.exports = __webpack_public_path__ + "static/misak-fc5d19b611272c9b38f062612a22673d.jpg";